import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/functions'

export const config = {
  apiKey: 'AIzaSyDEOk7kBO5U6lAacnEO5rt0KlB7Ghqdqkk',
  authDomain: 'aleksanderkomarov-web.firebaseapp.com',
  projectId: 'aleksanderkomarov-web',
  storageBucket: 'aleksanderkomarov-web.appspot.com',
  messagingSenderId: '105469908574',
  appId: '1:105469908574:web:cc6bedcf9ab516756a06cf'
}

export const app = firebase.initializeApp(config)
export const db = firebase.firestore()
export const auth = firebase.auth()
export const storage = firebase.storage()
export const functions = firebase.functions()
export const FieldValue = firebase.firestore.FieldValue
export const FieldPath = firebase.firestore.FieldPath

export const syncAuth = store => {
  app.auth().onAuthStateChanged(user => {
    if (user) {
      auth.currentUser.getIdTokenResult(true)
        .then(token => {
          return token.claims.role
        })
        .then(role => {
          const { uid, displayName, email, emailVerified, phoneNumber, photoURL } = user
          store.dispatch('updateUser', {
            uid,
            displayName: displayName || email,
            email,
            emailVerified,
            phoneNumber,
            photoURL,
            role
          })
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error)
          store.dispatch('clearUser')
        })
    } else {
      store.dispatch('clearUser')
    }
  })
}
